<template>
  <div class="purchase-modal" v-if="show">
    <div class="modal-content purchase-modal-content">
      <div class="modal-header">
        <button class="back-btn" @click="closeModal"><svg t="1747387769340" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4602" width="200" height="200"><path d="M374.2208 515.9424L774.912 115.2512a56.448 56.448 0 1 0-79.8464-79.8464L255.8976 474.5984c-22.016 22.016-22.016 57.7792 0 79.8208 1.7408 1.7408 3.712 3.1232 5.632 4.608 0.3072 0.3328 0.5632 0.768 0.896 1.1008l428.8768 428.8768a55.1168 55.1168 0 1 0 77.952-77.952L374.2208 515.9424z" fill="#F8B62D" p-id="4603"></path></svg> <span>返回</span></button>
      </div>
      
      <!-- 添加支付方式选择 -->

      <div class="payment-type">
        <PlatformSwitch v-model="paymentType" class="animate-fade-in animate-delay-2"/>
        <!-- <div 
          class="payment-option" 
          :class="{ active: paymentType === '微信' }"
          @click="paymentType = '微信'"
        >
          <span>微信支付</span>
        </div>
        <div 
          class="payment-option" 
          :class="{ active: paymentType === '支付宝' }"
          @click="paymentType = '支付宝'"
        >
          <span>支付宝</span>
        </div> -->
      </div>

      <div class="modal-body">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state">
          <div class="spinner"></div>
          <p>加载中...</p>
        </div>

        <!-- 错误状态 -->
        <div v-else-if="error" class="error-state">
          <p>{{ error }}</p>
          <button @click="fetchProducts">重试</button>
        </div>

        <!-- 商品列表 -->
        <div v-else>
          <div v-if="paymentType === '微信'" class="price-list">
            <div 
              v-for="product in products" 
              :key="product.id" 
              class="price-item"
              :class="{ 'selected': selectedProduct && selectedProduct.id === product.id }"
              @click="selectProduct(product)"
            >
              <div class="price-amount">{{ product.price }} 元</div>
              <div class="api-count">{{ product.api_count }}次</div>
            </div>
          </div>

          <!-- 支付宝提示 -->
          <div v-else class="alipay-notice">
            <img src="/微信.jpg" alt="微信支付" class="wechat-img"/>
            <p class="notice-text">添加客服使用使用支付宝付款</p>
          </div>
        </div>

        <!-- 确认购买按钮 -->
        <div class="purchase-actions" v-if="!loading && !error && paymentType === '微信'">
          <button 
            class="confirm-btn" 
            :disabled="!selectedProduct || processingOrder"
            @click="confirmPurchase"
          >
            {{ processingOrder ? '处理中...' : '确认购买' }}
          </button>
        </div>
      </div>

      <!-- 支付二维码弹窗 -->
      <div class="qr-modal" v-if="showQrCode">
        <div class="qr-content">
          <h4>请使用微信扫码支付</h4>
          <div class="qr-amount">¥{{ orderAmount }}</div>
          <img :src="qrCodeUrl" alt="支付二维码" class="qr-image" v-if="qrCodeUrl"/>
          <div class="qr-info">
            <p>商品：{{ orderProductName }}</p>
            <p>订单号：{{ orderNo }}</p>
          </div>
          <div class="refresh-notice">
            <p>支付成功后请手动刷新网页</p>
          </div>
          <button class="close-qr-btn" @click="closeQrCode">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PlatformSwitch from '@/components/WeChatAliPaySwitch.vue';

export default {
  components: {
    PlatformSwitch
  },
  name: 'PurchaseModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      paymentType: '微信', // 添加支付方式状态
      products: [],
      loading: false,
      error: null,
      selectedProduct: null,
      processingOrder: false,
      showQrCode: false,
      qrCodeUrl: '',
      orderNo: '',
      orderAmount: 0,
      orderProductName: '',
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.fetchProducts();
      }
    }
  },
  methods: {
    closeModal() {
      this.selectedProduct = null;
      this.showQrCode = false;
      this.$emit('close');
    },
    async fetchProducts() {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.get('https://app.zaizhexue.top/api/payment/products');
        if (response.data.success) {
          this.products = response.data.data.products;
        } else {
          this.error = '获取商品信息失败';
        }
      } catch (error) {
        console.error('获取商品列表失败:', error);
        this.error = '获取商品信息失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    },
    selectProduct(product) {
      this.selectedProduct = product;
    },
    async confirmPurchase() {
      if (!this.selectedProduct || this.processingOrder) return;
      
      this.processingOrder = true;
      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
          'https://app.zaizhexue.top/api/payment/create-order',
          { product_id: this.selectedProduct.id },
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data.success) {
          const orderData = response.data.data;
          this.qrCodeUrl = orderData.qr_url;
          this.orderNo = orderData.out_trade_no;
          this.orderAmount = orderData.amount;
          this.orderProductName = orderData.product_name;
          this.showQrCode = true;
        } else {
          this.error = response.data.error || '创建订单失败';
        }
      } catch (error) {
        console.error('创建订单失败:', error);
        this.error = '创建订单失败，请稍后重试';
      } finally {
        this.processingOrder = false;
      }
    },
    closeQrCode() {
      this.showQrCode = false;
      this.qrCodeUrl = '';
      this.orderNo = '';
      this.selectedProduct = null;
    }
  }
}
</script>
<style scoped>
.purchase-modal {
  transition: all 1s;
  /* 保留原有样式 */
}

.purchase-modal-content{
  border-radius: 24px;
}

.price-item {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 10px;
}

.price-item:hover {
  background-color: #fff5e0;
  /* border-color: #f8b62d; */
  transform: translateY(-2px);
  border-color: #ffffff;
  /* box-shadow: 0 2px 8px rgba(248, 182, 45, 0.2); */
  cursor: pointer;
}

.price-item.selected {
  border-color: #F8B62D;
  background-color: rgba(248, 182, 45, 0.1);
  box-shadow: 0 2px 8px rgba(248, 182, 45, 0.2);
}




.purchase-actions {
  margin-top: 20px;
  text-align: center;
}

.confirm-btn {
  background-color: #F8B62D;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background-color: #fcc454;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(249, 167, 96, 0.2);
}

.confirm-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.confirm-btn:disabled:hover {
  background-color: #ccc;
  transform: translateY(0px);
  box-shadow: 0 0px 0px rgba(249, 167, 96, 0.2);
}

/* .confirm-btn:not(:disabled):hover {
  background-color: #e6a41c;
} */

.qr-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.qr-content {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
}

.qr-amount {
  font-size: 24px;
  font-weight: bold;
  color: #F8B62D;
  margin: 16px 0;
}

.qr-image {
  width: 200px;
  height: 200px;
  margin: 16px auto;
}

.qr-info {
  margin: 16px 0;
  color: #666;
  font-size: 14px;
}

.close-qr-btn {
  background-color: #f5f5f5;
  color: #666;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 16px;
}

.close-qr-btn:hover {
  background-color: #e5e5e5;
}

.api-count{
  font-size: 14px;
  color: #999;
}


/* 添加新的样式 */
.payment-type {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.payment-option {
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-option.active {
  border-color: #F8B62D;
  background-color: rgba(248, 182, 45, 0.1);
  color: #F8B62D;
}

.alipay-notice {
  text-align: center;
  padding: 20px;
}

.wechat-img {
  border-radius: 8px;
  max-width: 200px;
  margin-bottom: 20px;
}

.notice-text {
  color: #666;
  font-size: 14px;
}
.refresh-notice{
  background-color: rgba(248, 182, 45, 0.1);
  border:solid 1px #F8B62D;
  color:#F8B62D;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .purchase-modal-content
  {
    width: 300px;
    margin-left: 10px;
    margin-right: 10px
  }
  
}
</style>
